import { ISearchResultComponentFactory } from "../interfaces";

const filterItemMetaData: ISearchResultComponentFactory<string> = {

    key: "filterItemMetaData",

    createElement: value => {
        const element = document.createElement('p');
        element.className = "text-neutral-600 text-sm mt-1";
        element.innerHTML = value;
        return element;
    },
};

export default filterItemMetaData;
